export default "__VITE_ASSET__CQiFGTmp__"